import { render } from "./CollaboratorTable.vue?vue&type=template&id=05feacf3&scoped=true"
import script from "./CollaboratorTable.vue?vue&type=script&lang=js"
export * from "./CollaboratorTable.vue?vue&type=script&lang=js"

import "./CollaboratorTable.vue?vue&type=style&index=0&id=05feacf3&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05feacf3"]])

export default __exports__